import { useEffect, useRef } from "react";

// Presentational hero backdrop: soft aurora (CSS) + cursor-follow light.
// Deliberately no particle system — motion here is ambient depth, not decoration,
// and stays off the main thread so the living dashboard animates smoothly.
export const HeroBackdrop = ({ targetRef }) => {
  const lightRef = useRef(null);

  useEffect(() => {
    const host = targetRef?.current;
    if (!host) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const onMove = (e) => {
      const r = host.getBoundingClientRect();
      if (lightRef.current) {
        lightRef.current.style.left = `${e.clientX - r.left}px`;
        lightRef.current.style.top = `${e.clientY - r.top}px`;
      }
    };
    host.addEventListener("mousemove", onMove);
    return () => host.removeEventListener("mousemove", onMove);
  }, [targetRef]);

  return (
    <div aria-hidden="true">
      <div className="ros-aurora" />
      <div ref={lightRef} className="ros-cursor-light" />
    </div>
  );
};
